module.exports = __webpack_public_path__ + "img/galatasaray-logo-icon.1b3aceed.png";